var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForwardBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.928,
    height: 17.41,
    viewBox: "0 0 13.928 17.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-forward-10",
    "data-name": "Icon material-forward-10",
    transform: "translate(-5 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37821",
    "data-name": "Path 37821",
    d: "M17.187,11.7a5.223,5.223,0,1,1-5.223-5.223V9.955L16.317,5.6,11.964,1.25V4.732A6.964,6.964,0,1,0,18.928,11.7Z",
    fill: "#0d70d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37822",
    "data-name": "Path 37822",
    d: "M12.869,18.285V14.568h-.078l-1.541.548v.6l.879-.27v2.838Zm1.21-2.176v.644c0,1.654,1.14,1.584,1.254,1.584s1.254.078,1.254-1.584v-.644c0-1.654-1.14-1.584-1.254-1.584s-1.254-.078-1.254,1.584Zm1.776-.1v.844c0,.67-.183.9-.514.9s-.522-.226-.522-.9V16c0-.653.192-.879.514-.879S15.855,15.352,15.855,16Z",
    transform: "translate(-1.897 -4.03)",
    fill: "#0d70d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardBlue);
export default __webpack_public_path__ + "static/media/forward-blue.3f274b0e474c3d6dbfb41b53e91e67b5.svg";
export { ForwardRef as ReactComponent };